// extracted by mini-css-extract-plugin
export default {"brandPromo":"gF-z","carousel":"hF-z"};